import React, { useEffect } from "react";
import * as d3 from "d3";

interface SalaryDistributionFillProps {
    xScale: d3.ScaleLinear<number, number>;
    yScale: d3.ScaleLinear<number, number>;
    data: {
        percentile: number;
        salary: number;
    }[];
    d3Id: string;
}

export const SalaryDistributionFill = (props: SalaryDistributionFillProps) => {
    const { xScale, yScale, data, d3Id } = props;
    useEffect(() => {
        const area = d3
            .area()
            .curve(d3.curveLinear)
            .x(d => xScale((d as unknown as { percentile: number }).percentile))
            .y0(yScale(0))
            .y1(d => yScale((d as unknown as { salary: number }).salary));

        d3.select(`#${d3Id}`)
            .selectAll(".area-fill")
            .style("opacity", 0.4)
            .selectAll(".area")
            .data([data])
            .enter()
            .append("path")
            .attr("d", d =>
                area(d as unknown as [percentile: number, salary: number][])
            )
            .attr("fill", "url(#areachart_gradient)");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <g>
            {/* This creates the gradient background */}
            <defs>
                <linearGradient
                    id={"areachart_gradient"}
                    gradientTransform="rotate(90)"
                >
                    <stop offset="5%" stopColor="#6EEDB8" />
                    <stop offset="95%" stopColor="#54D2C7" />
                </linearGradient>
            </defs>
            <g className="area-fill"></g>
        </g>
    );
};
